import { Directive, DestroyRef, ElementRef, inject, output } from '@angular/core';

// Reemplaza los `document.addEventListener('click', ...)` manuales de _nav.js (usados para
// cerrar el panel de notificaciones). Se adjunta al contenedor que debe cerrarse — emite
// una vez por click fuera de sus límites, sin acoplarse a qué hace el consumidor con eso.
@Directive({
  selector: '[appClickOutside]',
  standalone: true,
})
export class ClickOutsideDirective {
  private readonly elementRef = inject(ElementRef<HTMLElement>);

  readonly appClickOutside = output<void>();

  constructor() {
    document.addEventListener('click', this.onDocumentClick, { capture: true });
    inject(DestroyRef).onDestroy(() => {
      document.removeEventListener('click', this.onDocumentClick, { capture: true });
    });
  }

  private readonly onDocumentClick = (event: MouseEvent): void => {
    const target = event.target as Node | null;
    if (target && !this.elementRef.nativeElement.contains(target)) {
      this.appClickOutside.emit();
    }
  };
}
